<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <v-tab
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }"
        exact>
        {{ opcion.nombre }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBarContratos',
  data() {
    return {
      opciones: [
        // Grupo 1 - Información Esencial
        { nombre: 'Generales', ruta: 'contrato' },
        { nombre: 'Catálogo', ruta: 'contratoCatalogo' },
        { nombre: 'Programa', ruta: 'contratoPrograma' },
        // Grupo 2 - Financiero
        { nombre: 'Autorizaciones', ruta: 'contratoRecursos' },
        { nombre: 'Anticipos', ruta: 'contratoAnticipos' },
        { nombre: 'Deducciones', ruta: 'contratoDeducciones' },
        // Grupo 3 - Legal/Garantías
        { nombre: 'Fianzas', ruta: 'contratoFianzas' },
        { nombre: 'Convenios', ruta: 'contratoConvenios' },
        { nombre: 'Firmas', ruta: 'contratoFirmas' },
        // Grupo 4 - Supervisión y Ejecución
        { nombre: 'Responsables', ruta: 'contratoResponsables' },
        { nombre: 'Superintendente', ruta: 'contratoSuperintendentes' },
        { nombre: 'Actividades', ruta: 'contratoActividades' },
        { nombre: 'Diario', ruta: 'contratoDiarioActividades' },
        // Grupo 5 - Documentación
        { nombre: 'Expediente', ruta: 'contratoExpediente' },
        { nombre: 'Relacionados', ruta: 'contratoContratosRelacionados' },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
